/**
 * This component provides a functionality to user to confirm phone number into My Account
 */
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { IBreadcrumb } from '../../../core/breadcrumb/breadcrumbs.model';
import { BreadcrumbsService } from '../../../core/breadcrumb/breadcrumbs.service';
import { BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ConformationCodeValidator } from '../validators/conformation-code-validator';
import { UserSession } from '@mem-shared/user-session';
import { UpdateProfileService } from '../update-profile.service';


@Component({
  selector: 'mem-confirm-phone-number',
  templateUrl: './confirm-phone-number.component.html',
  styleUrls: ['./confirm-phone-number.component.scss']
})

/**
 *  Confirm Phone Number from My Profile and Email Text Promo
 */
export class ConfirmPhoneNumberComponent implements OnInit {
  // to show success confirm modal
  @ViewChild('confirmSuccessModal') confirmSuccessModal: ModalDirective;
  @ViewChild('confirmSentModal') confirmSentModal: ModalDirective;

  // to check if the form is submitted or not
  submitted: Boolean = false;
  // error handling
  showServiceError: Boolean;
  //  variable to confirm phone number error
  confirmPhoneError: Boolean;
  // Form group for confirm phone number 
  confirmPhoneNumberForm: FormGroup;
   // check MFA verification
   showMultiFactor: Boolean;
     // Variable to show error message
  loading: boolean;

  constructor(public breadcrumbsService:BreadcrumbsService,public updateProfileService: UpdateProfileService, private router: Router, private fb: FormBuilder, public userSession: UserSession) { }

  ngOnInit() {
    this.showMultiFactor = (this.userSession.getMemberFeatureFlags().showMultiFactorAuthConsent == true) && (this.userSession.getMemberFeatureFlags().contactEmailConfirmed || this.userSession.getMemberFeatureFlags().contactPhoneConfirmed);
    this.submitted = false;
    this.confirmPhoneError = false;
    this.createConfirmPhoneNumberForm();
    this.setBreadcrumbs();
  }

  /**
  * This function calls the confirmPhoneNumber json by passing verification code entered by the user as parameter
  */
  confirmSubmission() {
    this.submitted = true;
    this.confirmPhoneError = false;
    this.loading = true;
    if (this.confirmPhoneNumberForm.valid) {
      // service call
      this.updateProfileService.confirmPhoneNumberUrl(this.verificationCode.value)
        .subscribe(
        data => {
          this.confirmPhoneError = false;
          this.loading = false;
          // This shows modal pop up when successful response is recieved
          this.confirmSuccessModal.show();
        },
        (errorRes) => {
          this.loading = false;
          if (errorRes.error.code === '010.007') {
            this.confirmPhoneError = true;
          } else {
            this.showServiceError = true;
          }
        }
        );
    }else{
      this.loading = false;
    }
  }

  /**
   * This function is called on click of resend confirmation link
   */
  resendConfirmationCode() {
    this.submitted = false;
    this.updateProfileService.resendPhoneActivationCode().subscribe(
      data => {
        this.confirmSentModal.show();
      },
      (errorRes) => {
        this.showServiceError = true;
      }
    );
  }

  // getting verification code from form
  get verificationCode() {
    return this.confirmPhoneNumberForm.get('verificationCode');
  }

  /* Creating form using form builder */
  createConfirmPhoneNumberForm() {
    this.confirmPhoneNumberForm = this.fb.group(
      {
        verificationCode: ['', [Validators.required, ConformationCodeValidator]]
      },
      { updateOn: 'submit' }
    );
  }

/**
 * This function is used to navigate to the previous page from where it is being called
 */
goToPreviousPage() {
  
  if(this.userSession.getSession('previousUrl') == "/profile/policyHolder" || this.userSession.getSession('previousUrl') == "/profile/policyHolder/home"){
    this.router.navigate(["/profile/communicationpreference"]);
  }else{
    this.router.navigate([this.userSession.getSession('previousUrl')]);
  }  
}
  /**
   * This function is used to load breadcrumbs for account recovery page based on conditions
   */
  setBreadcrumbs() {
    if(this.showMultiFactor && (this.userSession.getSession('previousUrl') === '/emailTextPromo/home' || this.userSession.getSession('previousUrl') === '/emailTextPromo')) {  
         
      let breadcrumb: IBreadcrumb[] = [{
        label: 'Two step Verification',
        params: {},
        url: '/emailTextPromo/home'
      },
      {
        label: 'Confirm Mobile Phone Number',
        params: {},
        url: ''
      }]; 
      this.breadcrumbsService.store(breadcrumb);
    } 
    if(!this.showMultiFactor && (this.userSession.getSession('previousUrl') === '/emailTextPromo/home' || this.userSession.getSession('previousUrl') === '/emailTextPromo')) {  
     
      let breadcrumb: IBreadcrumb[] =[
        {
        label: 'Account Recovery',
        params: {},
        url: '/emailTextPromo/home'
      },
      {
        label: 'Confirm Mobile Phone Number',
        params: {},
        url: ''
      }];
      this.breadcrumbsService.store(breadcrumb);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/update-profile/confirm-phone-number/confirm-phone-number.component.ts